import { render, staticRenderFns } from "./one2onechoice.vue?vue&type=template&id=2967ec46&scoped=true&"
import script from "./one2onechoice.vue?vue&type=script&lang=js&"
export * from "./one2onechoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2967ec46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2967ec46')) {
      api.createRecord('2967ec46', component.options)
    } else {
      api.reload('2967ec46', component.options)
    }
    module.hot.accept("./one2onechoice.vue?vue&type=template&id=2967ec46&scoped=true&", function () {
      api.rerender('2967ec46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/one2onechoice/one2onechoice.vue"
export default component.exports